let timeOutHandler;
export default function showErrorMessage(message, hideNow = false, showHTML = false, notice = false) {
    if (hideNow) {
        jQuery('.darwin-ajax-error--js').fadeOut();
    } else {
        if (message) {

            if(showHTML){
                jQuery('.darwin-ajax-error__message--js').html(message);
            }else{
                jQuery('.darwin-ajax-error__message--js').text(message);
            }

            if(notice){
                jQuery('.darwin-ajax-error--js').addClass('darwin-ajax-error--notice');
            }

            jQuery('.darwin-ajax-error--js').show();

            if(timeOutHandler){
                clearTimeout(timeOutHandler);
            }

            timeOutHandler = window.setTimeout(() => {
                jQuery('.darwin-ajax-error--js').fadeOut();
                jQuery('.darwin-ajax-error__message--js').removeClass('active');
                jQuery('.darwin-ajax-error--js').removeClass('darwin-ajax-error--notice');
            }, 10000);

        } else if (window.debug) {
            console.warn('No error message!');
        }
    }
}